import React, { useEffect, useState, useRef } from 'react';
import styles from './RichText.module.scss';
import cx from 'classnames';
export interface RichTextProps {
	content: string;
	className?: string;
	textColor?: string;
}

export const RichText: React.FC<RichTextProps> = ({ content, className, textColor }) => {
	// Make tables inside richtext editor responsive
	const width = 'width';
	const [downloadIcon, setDownloadIcon] = useState<string>();
	const richTextRef = useRef<HTMLDivElement>(null);
	
	useEffect(() => {
		if (richTextRef.current) {
			const iconColor = getComputedStyle(richTextRef.current)
				.getPropertyValue('--color-primary')
				.trim();
			
			const svg = createDownloadIcon(iconColor);

			setDownloadIcon(svg);
		}

		const contentTable = document.querySelectorAll('[class*="RichText"] table')
		if ( document.querySelector('.table-responsive') )
			return null; // if check is already performed we do not want to do it again.

		for (let i = 0; i < contentTable.length; i++) {
			const tableWrap = document.createElement('div');
			tableWrap.classList.add('table-responsive');
			contentTable[i].parentNode.insertBefore(tableWrap, contentTable[i]);
			tableWrap.appendChild(contentTable[i]);
			// lastly set width on table so it does not shrink and get ugly on smaller screens
			contentTable[i].setAttribute(width, contentTable[i].clientWidth.toString())
		}

	}, []);

	return <div ref={richTextRef}
				className={cx(styles.RichText, className)}  
				style={{
					...(textColor ? { '--text-color-override': textColor } as React.CSSProperties : {}),
					...(downloadIcon ? { '--download-icon': downloadIcon } as React.CSSProperties : {}),
				}}
				dangerouslySetInnerHTML={{ __html: content }} />;
};


const createDownloadIcon = (color: string) => {
	const svg = `
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M3.40234 17.4133L3.40234 28.8261H11.0023H20.5028H28.1023V17.4133"
				stroke="${color}"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"/>
			<path d="M15.7516 2.66058L15.753 21.1808M15.753 21.1808L10.5266 15.0006M15.753 21.1808L20.9766 15.0006"
				stroke="${color}"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"/>
		</svg>
	`;

	return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

